<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" :model="queryParam" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-model-item :label="$t('dashboard.order.siteName')" prop="name">
              <a-input :placeholder="$t('dashboard.order.placeholderSiteName')" v-model="queryParam.name"/>
            </a-form-model-item>
          </a-col>
          <template v-if="toggleSearchStatus">
          </template>
          <a-col :md="6" :sm="8">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('antd.table.search') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload"
                          style="margin-left: 8px">{{ $t('antd.table.reset') }}</a-button>
              </span>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('antd.table.add') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <a-alert type="info" showIcon style="margin-bottom: 16px;">
      <template slot="message">
        <span>{{ $t('antd.table.selected') }}</span>
        <a style="font-weight: 600;padding: 0 4px;">{{ selectedRowKeys.length }}</a>
        <span>{{ $t('antd.table.item') }}</span>
        <template v-if="selectedRowKeys.length>0">
          <a-divider type="vertical"/>
          <a @click="onClearSelected">{{ $t('antd.table.clear') }}</a>
        </template>
      </template>
    </a-alert>

    <!-- 表格容器 -->
    <div class="table-container">
      <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          :scroll="{ x: 'max-content' }"
          @change="handleTableChange">

        <template slot="action" slot-scope="text, record">
          <a @click="handleActic(record)">{{ $t('dashboard.analysis.stash') }}</a>
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)">{{ $t('antd.table.edit') }}</a>
          <a-divider type="vertical"/>
          <a @click="handleDelete(record.id)">{{ $t('antd.table.delect') }}</a>
          <a-divider type="vertical"/>
          <a @click="() => printSiteLabel(record.id)">{{ $t('antd.table.print') }}</a>
        </template>
      </a-table>
    </div>

    <!-- 表单区域 -->
    <AisleModeCreate :siteCodeData="siteZipcodeData" ref="modalForm" @ok="modalFormOk"></AisleModeCreate>
  </div>
</template>

<script>
import AisleModeCreate from './modules/AisleModeCreate.vue'
import {TableListMixin} from '@/situation/mixins/tableListMixin'
import {siteZipcode, printSiteLabel} from 'api/app'

export default {
  name: 'SysCheckRuleList',
  mixins: [TableListMixin],
  components: {AisleModeCreate},
  data() {
    return {
      siteZipcodeData: [],
      queryParam: {},
      toggleSearchStatus: true,
      selectedRowKeys: [],
      printQuantity: 1, // 打印数量
      description: '编码校验规则管理页面',
      // 表头
      columns: [
        // {
        //   title: this.$t("antd.table.index"),
        //   key: 'rowIndex',
        //   width: 60,
        //   align: 'center',
        //   fixed: 'left',
        //   customRender: (t, r, i) => i + 1
        // },
        {
          title: this.$t("dashboard.order.siteName"),
          align: 'center',
          fixed: 'left',
          width: 180,
          dataIndex: 'name'
        },
        {
          title: this.$t("dashboard.analysis.countryCode"),
          align: 'center',
          width: 100,
          dataIndex: 'countryCode'
        },
        {
          title: this.$t("dashboard.analysis.stateProvince"),
          align: 'center',
          width: 180,
          dataIndex: 'stateProvince'
        },
        {
          title: this.$t("dashboard.analysis.city"),
          align: 'center',
          width: 180,
          dataIndex: 'city'
        },
        {
          title: this.$t("dashboard.analysis.address"),
          align: 'center',
          width: 280,
          dataIndex: 'address'
        },
        {
          title: this.$t("dashboard.analysis.postalCode"),
          align: 'center',
          width: 150,
          dataIndex: 'postalCode'
        },
        {
          title: this.$t("dashboard.analysis.serviceRadius"),
          align: 'center',
          width: 180,
          dataIndex: 'serviceRadius'
        },
        {
          title: this.$t("dashboard.analysis.contactPhone"),
          align: 'center',
          width: 120,
          dataIndex: 'contactPhone'
        },
        {
          title: this.$t("dashboard.analysis.businessCondition"),
          align: 'center',
          width: 180,
          dataIndex: 'businessCondition',
          customRender: (text) => {
            return text == 1 ? this.$t("dashboard.analysis.operating") : this.$t("dashboard.analysis.resting");
          }
        },
        {
          title: this.$t("dashboard.analysis.businessTime"),
          align: 'center',
          width: 200,
          dataIndex: 'businessTime'
        }, {
          title: this.$t("dashboard.analysis.pos"),
          align: 'center',
          width: 150,
          dataIndex: 'pos'
        }, {
          title: this.$t("dashboard.analysis.addressLink"),
          align: 'center',
          width: 300,
          dataIndex: 'addressLink',
          customRender: (text) => {
            // 限制最多显示100个字符
            const maxLength = 100;
            const truncatedText = text && text.length > maxLength
                ? text.substring(0, maxLength) + '...'
                : text;

            return {
              children: (
                  <a-tooltip placement="top" title={text}>
                    <span>{truncatedText}</span>
                  </a-tooltip>
              )
            };
          }
        },
        {
          title: "袋号规则",
          align: 'center',
          width: 150,
          dataIndex: 'bagNumberRulesName'
        },
        {
          title: this.$t("antd.table.batch"),
          dataIndex: 'action',
          align: 'center',
          width: 200,
          fixed: 'right',
          scopedSlots: {customRender: 'action'},
        }
      ],
      url: {
        selectData: '/ndt/site/page',
        deleteData: '/ndt/site/delete',
      },
    }
  },
  async mounted() {
    await this.getsiteZipcode()
  },
  methods: {
    getsiteZipcode() {
      siteZipcode().then(res => {
        if (res.code == '200') {
          this.siteZipcodeData = res.data
        }
      })
    },
    handleActic(event) {
      this.$emit('onActic', event)
    },
    async printSiteLabel(id) {
      this.printQuantity = 1
      // 显示输入框让用户选择打印数量
      this.$confirm({
        title: '打印设置',
        content: h => {
          return h('div', [
            h('p', '请输入需要打印的面单数量：'),
            h('a-input-number', {
              props: {
                min: 1,
                max: 100,
                value: this.printQuantity || 1,
                style: 'width: 200px'
              },
              on: {
                change: (value) => {
                  this.printQuantity = value;
                }
              }
            })
          ]);
        },
        onOk: async () => {
          try {
            const params = {
              id: id,
              quantity: this.printQuantity || 1
            };
            const response = await printSiteLabel(params);

            if (!response) {
              throw new Error('无效的PDF数据');
            }

            const pdfBlob = new Blob([response.data || response], {type: 'application/pdf'});

            if (pdfBlob.size === 0) {
              throw new Error('生成的PDF内容为空');
            }

            const pdfUrl = URL.createObjectURL(pdfBlob);
            const pdfWindow = window.open(pdfUrl, '_blank');

            if (!pdfWindow || pdfWindow.closed) {
              const iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src = pdfUrl;
              document.body.appendChild(iframe);
              this.printQuantity = 1
              setTimeout(() => {
                document.body.removeChild(iframe);
                URL.revokeObjectURL(pdfUrl);
              }, 10000);
            }

            setTimeout(() => {
              URL.revokeObjectURL(pdfUrl);
              if (pdfWindow && !pdfWindow.closed) {
                pdfWindow.close();
              }
            }, 1800000);

          } catch (error) {
            console.error('PDF打开失败:', error);
            this.$message.error(`文件预览失败: ${error.message}`);
          }
        },
        onCancel: () => {
          // 用户取消，不执行任何操作
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import '~assets/less/common.less';

/* 表格容器样式 */
.table-container {
  margin-bottom: 16px;
}
</style>
